import {
    IOfferProductTemplateModel
} from "../../../../../../../models/offer/product/templates/IOfferProductTemplateModel";
import {Resources} from "../../../../../../../resources/Resources";
import {OfferProductSolutionType} from "../../../../../../../models/offer/product/solution/OfferProductSolutionType";
import {IOfferContentsTable, IOfferContentsTableEntry, IOfferContentsTableIcon} from "./IOfferContentsTable";

export class OfferContents {

    static table(templates: IOfferProductTemplateModel[]): IOfferContentsTable[] {
        let table: IOfferContentsTable[] = [
            {
                name: Resources.t("words.briefContentSeoWriting"),
                entries: [],
                description: Resources.t("words.briefContentSeoWritingDescription"),
                solutionType: OfferProductSolutionType.BRIEF_CONTENT,
                type: "text"
            }, {
                name: Resources.t("words.automaticOptimization"),
                entries: [],
                description: Resources.t("words.automaticOptimizationDescription"),
                solutionType: OfferProductSolutionType.OPTIMIZATION_CONTENT,
                type: "text"
            }, {
                name: Resources.t("words.seoOptimizedBlogContents"),
                entries: [],
                description: Resources.t("words.generateContentDescription"),
                solutionType: OfferProductSolutionType.AI_CONTENT,
                type: "text"
            }, {
                name: Resources.t("words.topicsAndClusters"),
                entries: [],
                description: Resources.t("words.topicsAndClustersDescription"),
                solutionType: OfferProductSolutionType.SEO_CLUSTER,
                type: "text"
            }, {
                name: Resources.t("words.teamMembers"),
                entries: [
                    {value: `<span>1</span> ${Resources.t("words.singleMember")}`},
                    {value: `<span>3</span> ${Resources.t("words.multipleMembers")}`},
                    {value: `<span>10</span> ${Resources.t("words.multipleMembers")}`}
                ],
                entriesCustom: true,
                description: Resources.t("words.teamMembersDescription"),
                solutionType: undefined,
                addToContents: true,
                type: "text"
            }
            , {
                name: Resources.t("words.competitorAnalysis"),
                description: Resources.t("words.analyzeCompetitorsDescription"),
                addToContents: true,
                entries: [],
                solutionType: OfferProductSolutionType.SEO_RANKING,
                type: "bool",
                boolMin: 1
            },
            {
                name: Resources.t("words.multiLanguageSites"),
                description: Resources.t("words.generateMultiLangContentDescription"),
                entries: [],
                addToContents: true,
                solutionType: OfferProductSolutionType.COMMUNITY,
                type: "textBool",
                boolMin: 1
            }, {
                name: Resources.t("words.integrationWithYourSite"),
                description: Resources.t("words.connectYourSiteDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool",
                icons: [IOfferContentsTableIcon.PRESTASHOP, IOfferContentsTableIcon.SHOPIFY, IOfferContentsTableIcon.WORDPRESS, IOfferContentsTableIcon.WIX, IOfferContentsTableIcon.WEBFLOW]
            },
            {
                name: Resources.t("words.seoPositionTracking"),
                description: Resources.t("words.seoPositionTrackingDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            }, {
                name: Resources.t("words.textHumanization"),
                description: Resources.t("words.textHumanizationDescription"),
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: Resources.t("words.autopilot"),
                description: Resources.t("words.automaticPilotDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            }, {
                name: Resources.t("words.keywordResearch"),
                description: Resources.t("words.keywordResearchDescription"),
                entries: [],
                addToContents: true,
                solutionType: undefined,
                type: "bool"
            }, {
                name: Resources.t("words.internalLinks"),
                description: Resources.t("words.internalLinksDescription"),
                entries: [],
                addToContents: true,
                solutionType: undefined,
                type: "bool"
            }, {
                name: Resources.t("words.googleSearchConsole"),
                description: Resources.t("words.googleSearchConsoleDescription"),
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: Resources.t("words.onboardingHelp"),
                description: Resources.t("words.contactUsForAssistanceDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
        ];

        templates.forEach(product => {
            let bundle = product.bundles[0];


            table.forEach(tableLine => {
                let solution = bundle.solutions.find(value => value.type == tableLine.solutionType);
                let entry: IOfferContentsTableEntry = {templateId: product.id};

                switch (tableLine.type) {
                    case "text":
                        if (solution) {
                            entry.value = `<span>${solution.quantityInitial}</span> ${Resources.t(`words.offerSolution${product.type}${product.productType}${solution.type}`)}`
                        }
                        break;
                    case "textBool":
                        if (solution && solution.quantityInitial > tableLine.boolMin) {
                            entry.value = `<span>${solution.quantityInitial}</span> ${Resources.t(`words.offerSolution${product.type}${product.productType}${solution.type}`)}`
                        }
                        break;
                    case "bool":
                        if (solution) {
                            if (solution.quantityInitial > tableLine.boolMin) {
                                entry.value = true;
                            }
                        } else {
                            entry.value = true;
                        }
                        break;
                }

                if (!tableLine.entriesCustom)
                    tableLine.entries.push(entry);
            })
        })

        return table;
    }

    static hiddenTypes(): OfferProductSolutionType[] {
        return [OfferProductSolutionType.SEO_RANKING, OfferProductSolutionType.WRITING_STYLE, OfferProductSolutionType.SEO_AUDIT];
    }

    static popularTemplates(): string[] {
        return ["17778c6ca54349a69a4999ca218aced9"];
    }

    static contents(baseContents: string[], template: IOfferProductTemplateModel): string[] {
        let table = this.table([template]);
        table.forEach(tableLine => {
            if (tableLine.addToContents) {
                let value = tableLine.entries.find(value => value.templateId == template.id)?.value;

                if (value !== undefined) {
                    if (!value || tableLine.type == "bool") {
                        value = tableLine.name;
                    }

                    baseContents.push(value);
                }
            }
        });
        return baseContents;
    }
}